import logo from '@/assets/logo.png';

type LoadingProps = {
    /** Optional message describing the action being performed */
    action?: string;
};

/**
 * A loading indicator component that optionally displays an action message.
 * Covers the entire parent container with a semi-transparent background.
 */
export function Loading({ action }: LoadingProps) {
    return (
        // Overlay container: absolute positioning, covers parent, flex center
        // Added subtle background, blur, and z-index
        <div className="absolute inset-0 z-50 flex items-center justify-center">
            {/* Content container: column layout, centered items, styled box */}
            <div className="flex flex-col items-center rounded-lg bg-background-primary p-6 shadow-lg">
                {/* Logo */}
                <img
                    src={logo}
                    className="h-10 object-contain" // Use object-contain to prevent distortion
                    height={40}
                    alt="elektra app logo" // Added alt text
                />

                <p className="mt-4 text-sm font-medium text-text-primary animate-pulse">
                    {action ?? 'loading'}
                    ...
                </p>
            </div>
        </div>
    );
}
